import React, { useState, useRef, useEffect } from "react";
import { Col, Row } from "reactstrap";
import UserProfileInput from "./UserProfileInput";
import UserProfileCountry from "./UserProfileCountry";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from "react-redux";
import { addCreditCardInfo } from "../../redux/thunks/userThunks";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import "./SettingsAccountNewCard.css";

const stripeStyleOptions = {
  style: {
    base: {
      fontSize: "16px",
      color: "#1d1d1f",
      fontFamily: "inherit",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
    },
  },
};

const SettingsAccountNewCard = () => {
  const [formData, setFormData] = useState({
    cardholderName: "",
    email: "",
    address1: "",
    address2: "",
    city: "",
    province: "",
    postal_code: "",
    country: "",
  });
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const toast = useRef(null);
  const loginUser = useSelector((state) => state.user.user.data);

  useEffect(() => {
    if (loginUser) {
      setFormData((prev) => ({
        ...prev,
        cardholderName: `${loginUser.first_name} ${loginUser.last_name}`,
        email: loginUser.email,
      }));
    }
  }, [loginUser]);

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    try {
      await dispatch(
        addCreditCardInfo(
          elements,
          formData,
          loginUser.email,
          loginUser.customer_enable,
          stripe
        )
      );
      elements.getElement(CardNumberElement).clear();
      elements.getElement(CardExpiryElement).clear();
      elements.getElement(CardCvcElement).clear();
      setFormData((prev) => ({
        ...prev,
        cardholderName: `${loginUser.first_name} ${loginUser.last_name}`,
        email: loginUser.email,
      }));

      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Credit card added successfully.",
      });
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.message || "Failed to add card.",
      });
    }
  };

  return (
    <div className="col-xl-10">
      <Toast ref={toast} />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Adding New Payment Card</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} className="personal_validate">
            <div className="form-row">
              <UserProfileInput
                fieldLabel="Cardholder's Name"
                name="cardholderName"
                value={formData.cardholderName}
                onChange={handleChange("cardholderName")}
                disabled={true}
              />
              <UserProfileInput
                fieldLabel="Address Line 1"
                value={formData.address1}
                onChange={handleChange("address1")}
              />
              <UserProfileInput
                fieldLabel="Address Line 2"
                value={formData.address2}
                onChange={handleChange("address2")}
              />

              <Row className="align-items-center">
                <Col xs={6}>
                  <UserProfileInput
                    fieldLabel="City"
                    value={formData.city}
                    onChange={handleChange("city")}
                  />
                </Col>
                <Col xs={6}>
                  <UserProfileInput
                    fieldLabel="State/Province"
                    value={formData.province}
                    onChange={handleChange("province")}
                  />
                </Col>
              </Row>

              <Row className="align-items-center">
                <Col xs={6}>
                  <UserProfileInput
                    fieldLabel="Postal Code"
                    value={formData.postal_code}
                    onChange={handleChange("postal_code")}
                  />
                </Col>
                <Col xs={6}>
                  <UserProfileCountry
                    fieldLabel="Country"
                    value={formData.country}
                    onChange={handleChange("country")}
                  />
                </Col>
              </Row>
              <div className="form-group col-12">
                <label>Card Number</label>
                <div className="custom-stripe-input">
                  <CardNumberElement options={stripeStyleOptions} />
                </div>
              </div>
              <Row className="align-items-center">
                <Col xs={6}>
                  <div className="form-group">
                    <label>Expiration Date</label>
                    <div className="custom-stripe-input">
                      <CardExpiryElement options={stripeStyleOptions} />
                    </div>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="form-group">
                    <label>CVC</label>
                    <div className="custom-stripe-input">
                      <CardCvcElement options={stripeStyleOptions} />
                    </div>
                  </div>
                </Col>
              </Row>
              <div className="form-group col-12 mt-3">
                <Button type="submit" className="btn btn-success ps-5 pe-5">
                  Add Card
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SettingsAccountNewCard;
